<template>
  <section class="page-stack grid-stack grid-gap-page-section">
    <article class="page-panel page-panel--mobile-unframed grid-stack grid-gap-20">
      <h2>{{ pageTitle }}</h2>

      <v-table class="table">
        <thead>
          <tr>
            <th class="text-mid">Naziv</th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="activity in activityListState.activities"
            :key="activity.id"
          >
            <td class="body-1-regular">{{ activity.name }}</td>
          </tr>

          <tr v-if="activityListState.isLoadingActivities || !activityListState.activities.length">
            <td
              class="table__empty"
            >
              {{ activityListState.isLoadingActivities ? 'Učitavanje aktivnosti...' : 'Nema aktivnosti.' }}
            </td>
          </tr>
        </tbody>
      </v-table>
    </article>
  </section>
</template>

<script setup>
import { computed, onMounted, reactive } from 'vue'
import { useRoute } from 'vue-router'

import { apiClient } from '../../services/apiClient'
import { showRequestErrorToast } from '../../store/appStore'

const route = useRoute()
const activityListState = reactive({
  activities: [],
  isLoadingActivities: true,
})

const pageTitle = computed(() => route.meta.title)

onMounted(loadActivitiesAsync)

async function loadActivitiesAsync () {
  activityListState.isLoadingActivities = true

  try {
    activityListState.activities = await apiClient.getAsync('/api/activity-types')
  } catch (error) {
    console.error('Failed to load activities.', error)
    showRequestErrorToast(error, 'Aktivnosti nije bilo moguće učitati.')
  } finally {
    activityListState.isLoadingActivities = false
  }
}
</script>
